type ProductTypes = {
  [key: string]: string
}

const productTypes: ProductTypes = {
  'Wire rope hoist': 'HOIST',
  'Chain hoist': 'HOIST; CHAIN HOIST',
  'Machinery hoist (WRH)': 'HOISTING MACHINERY',
  'Manual chain block': 'MANUAL CHAIN BLOCK',
  'Condition monitoring unit': 'CONDITION MONITORING UNIT',
  'Frequency converter': 'FREQUENCY CONVERTER',
  'Hoisting motor': 'MOTOR; HOISTING MOTOR',
  'Hook block': 'HOOK BLOCK',
  'Radio controller': 'RADIO CONTROL SYSTEM',
  'Travelling machinery': 'TRAVELLING MACHINERY',
  'Travelling motor': 'MOTOR; TRAVELLING MOTOR',
}

export default productTypes
